import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '../Custom/Tabs/TabsContainer';
import CPressureSensorInstallForm from '../../containers/CPressureSensorInstall/CPressureSensorInstallForm';

const classNames = require('classnames');
const _ = require('lodash');

export default class PressureSensorInstallTabs extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { installMode, showDetails } = nextProps;
    if (!_.isEmpty(installMode.newInstallItem)) {
      if (!showDetails) {
        this.props.toggleDetailsVisibility(true);
      }
    }
  }

  componentWillUnmount() {
    if (this.props.showDetails) {
      this.props.toggleDetailsVisibility(false);
    }
  }

  closePanel = () => {
    this.props.toggleDetailsVisibility(false);
    this.props.clearSelectedFeature();
  };

  render() {
    const { uiInfo, showDetails, notify } = this.props;

    const panelStyle = { height: 0.493 * uiInfo.pageHeight };
    const panelClasses = classNames('alert-details', { show: showDetails });
    const title = this.context.t('install_new_pressure_sensor');

    const tabsList = [
      {
        label: this.context.t('install_pressure_sensor'),
        component: <CPressureSensorInstallForm notify={notify} />,
      },
    ];

    return (
      <div className={panelClasses} style={panelStyle}>
        <Tabs
          title={title}
          tabs={tabsList}
          handleClose={this.closePanel}
        />
      </div>
    );
  }
}

PressureSensorInstallTabs.contextTypes = {
  t: PropTypes.func.isRequired,
};
